export const productsTour = [
  { target: '.tour-products', content: 'This is our product catalog. Here you can choose a product to print your design on.', placement: 'center' },
];